import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatAmount, formatDateTime, formatLicensePlate } from "utils/localizations";
import type { ViewComponent } from "@frui.ts/views";
import Section from "views/common/section";
import CardGatewayDetailViewModel from "viewModels/finance/outgoingPayments/cardGatewayDetailViewModel";
import type BankTransferDetailViewModel from "viewModels/finance/outgoingPayments/bankTransferDetailViewModel";
import { emptyValue } from "utils/emptyValue";

const RefundChargeSection: ViewComponent<CardGatewayDetailViewModel | BankTransferDetailViewModel> = ({ vm }) => {
  const refundCharge = vm.item.refundCharge;
  let sm;
  let md;
  let lg;
  let lgSmallerField;

  if (vm instanceof CardGatewayDetailViewModel) {
    sm = 6;
  } else {
    sm = 12;
    md = 6;
    lg = 4;
    lgSmallerField = 2;
  }

  return (
    <Section title={vm.translate("charge")} context={refundCharge}>
      <div className="row">
        <Form.Group as={Col} sm={12} md={md} lg={lg}>
          <Form.Label>{vm.translate("licensePlate")}</Form.Label>
          <FakeInput
            target={refundCharge}
            property="vehicle"
            valueFormatter={vehicle => (vehicle ? formatLicensePlate(vehicle) : emptyValue)}
          />
        </Form.Group>
        <Form.Group as={Col} sm={sm} md={md} lg={lgSmallerField}>
          <Form.Label>{vm.translate("type")}</Form.Label>
          <FakeInput target={refundCharge} property="priceListItemId" valueFormatter={value => vm.chargeType(value)} />
        </Form.Group>
        <Form.Group as={Col} sm={sm} md={md} lg={lgSmallerField}>
          <Form.Label>{vm.translate("price")}</Form.Label>
          <FakeInput target={refundCharge} property="price" valueFormatter={value => formatAmount(value)} />
        </Form.Group>
        <Form.Group as={Col} sm={sm} md={md} lg={lgSmallerField}>
          <Form.Label>{vm.translate("validSince")}</Form.Label>
          <FakeInput target={refundCharge} property="validSince" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
        <Form.Group as={Col} sm={sm} md={md} lg={lgSmallerField}>
          <Form.Label>{vm.translate("validUntil")}</Form.Label>
          <FakeInput target={refundCharge} property="validUntil" valueFormatter={value => formatDateTime(value)} />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={md} lg={lg}>
          <Form.Label>{vm.translate("officialRecordId")}</Form.Label>
          <FakeInput target={refundCharge} property="officialRecordId" valueFormatter={value => (value ? value : emptyValue)} />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={md} lg={lg}>
          <Form.Label>{vm.translate("chargeOrderId")}</Form.Label>
          <FakeInput target={refundCharge} property="chargeOrderId" valueFormatter={value => (value ? value : emptyValue)} />
        </Form.Group>
        <Form.Group as={Col} sm={12} md={md} lg={lg}>
          <Form.Label>{vm.translate("chargeId")}</Form.Label>
          <FakeInput target={refundCharge} property="chargeId" valueFormatter={value => (value ? value : emptyValue)} />
        </Form.Group>
      </div>
    </Section>
  );
};

export default RefundChargeSection;
